import { LocalStorageService } from "../helpers";

const initialState = {
  value: LocalStorageService.getDBAddress() || "isb",
};

export const domainReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_DOMAIN":
      return {
        ...state,
        value: action.payload,
      };
    default:
      return state;
  }
};
